import React from 'react';
import { Container, Button, Box, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import styled from 'styled-components';
import { motion } from 'framer-motion';

// Context
import { useI18n } from '../context/I18nContext';

// Sections
import HeroSection from '../components/sections/HeroSection';
import AboutSection from '../components/sections/AboutSection';
import HowItWorksSection from '../components/sections/HowItWorksSection';
import CitiesPreviewSection from '../components/sections/CitiesPreviewSection';
import MapSection from '../components/sections/MapSection';
import DataSection from '../components/sections/DataSection';
import SponsorsSection from '../components/sections/SponsorsSection';

const HomePage: React.FC = () => {
  const { t } = useI18n();
  
  // Variantes de animação para os elementos
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.2
      }
    }
  };
  
  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <HeroSection />
      <AboutSection />
      <HowItWorksSection />
      <CitiesPreviewSection />
      <MapSection />
      <DataSection />
      <SponsorsSection />
    </motion.div>
  );
};

export default HomePage;
